import { useMutation } from "@tanstack/react-query";
import { createTicketSupport } from "../services/tickets-support.service";

export const useCreateTicketSupport = () =>
  useMutation({
    mutationFn: createTicketSupport,
  });
